var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8655 2H7.46282C6.00506 2 4.72608 2.9847 4.66766 4.40355C4.59415 6.18879 5.8497 7.37422 7.16841 8.4871C8.99267 10.0266 9.90481 10.7964 10.0005 11.7708C10.0155 11.9233 10.0155 12.0767 10.0005 12.2292C9.90481 13.2036 8.99268 13.9734 7.16841 15.5129C5.81338 16.6564 4.59036 17.7195 4.66766 19.5964C4.72608 21.0153 6.00506 22 7.46282 22H17.8655C19.3232 22 20.6022 21.0153 20.6606 19.5964C20.7071 18.4668 20.2885 17.342 19.3993 16.56C18.9939 16.2034 18.573 15.8615 18.1599 15.5129C16.3356 13.9734 15.4235 13.2036 15.3278 12.2292C15.3128 12.0767 15.3128 11.9233 15.3278 11.7708C15.4235 10.7964 16.3356 10.0266 18.1599 8.4871C19.5007 7.35558 20.737 6.25809 20.6606 4.40355C20.6022 2.9847 19.3232 2 17.8655 2Z",
    stroke: "#F49D1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66406 21.6381C9.66406 21.1962 9.66406 20.9752 9.75166 20.7821C9.76557 20.7514 9.78105 20.7214 9.79805 20.6923C9.90507 20.509 10.0862 20.3796 10.4484 20.1208C11.4546 19.4021 11.9576 19.0427 12.5293 19.0045C12.6191 18.9985 12.7091 18.9985 12.7989 19.0045C13.3706 19.0427 13.8736 19.4021 14.8798 20.1208C15.242 20.3796 15.4231 20.509 15.5301 20.6923C15.5471 20.7214 15.5626 20.7514 15.5765 20.7821C15.6641 20.9752 15.6641 21.1962 15.6641 21.6381V22H9.66406V21.6381Z",
    stroke: "#F49D1B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading-2.0e059018.svg";
export { ForwardRef as ReactComponent };